import { atom } from 'recoil';
import { PlayerOverviews } from '../../types/player';


export const playerOverviewsState = atom<PlayerOverviews>({
  key: 'playerOverviews',
  default: {},
});
